import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

const TIEMPO_DE_ESPERA_MAXIMO = 300000; // Tiempo de espera máximo en milisegundos (10 segundos en este caso)

const opcionesDeConfiguracion = {
  timeout: TIEMPO_DE_ESPERA_MAXIMO,
};
@Injectable({
  providedIn: 'root',
})
export class DocumentoNoTributarioService {
  constructor(private gqlclient: GraphQLClient) { }

  ObtenerResultadoAnalisis(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query (
            $empresa_rut: Decimal
            $sucursalCodigo: Decimal
            $fechaDesde: Date
            $fechaHasta: Date
            $codigoBodega: Decimal
            $unidadNegocio: Decimal
            $rutUsuario: Decimal
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            documento_no_tributario {
              obtenerResultadoAnalisis(
                rutEmpresa: $empresa_rut
                sucursalCodigo: $sucursalCodigo
                fechaDesde: $fechaDesde
                fechaHasta: $fechaHasta
                codigoBodega: $codigoBodega
                unidadNegocio: $unidadNegocio
                rutUsuario: $rutUsuario
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    cantidadRequerida
                    detalleAnalisisDemanda {
                      cantidadAtendida
                      folio
                      producto_codigo
                      producto_formato
                      estado
                      stock_tras_movimiento
                      stock_Actual
                      estadocodigo
                    }
                    diferenciaConStock
                    estado
                    folio
                    producto_codigo
                    producto_formato
                    stockActual
                    nombreFormato
                    nombreProducto
                    skuProducto
                    estadoAnalisisCodigo
                    cliente_nombre
                    cliente_proveedor_rut
                    vendedor
                    comuna
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_no_tributario.obtenerResultadoAnalisis;
        callback({ mensajes, respuesta });
      }
    );
  }

  CambiaProducto(inputParams, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation (
            $rutEmpresa: Decimal
            $sucursalCodigo: Decimal
            $productoCodigoOrigen: Decimal
            $formatoCodigoOrigen: String
            $productoCodigoDestino: Decimal
            $formatoCodigoDestino: String
            $codigoBodega: Decimal
          ) {
            documento_no_tributario {
              cambiaProducto(
                rutEmpresa: $rutEmpresa
                sucursalCodigo: $sucursalCodigo
                productoCodigoOrigen: $productoCodigoOrigen
                formatoCodigoOrigen: $formatoCodigoOrigen
                productoCodigoDestino: $productoCodigoDestino
                formatoCodigoDestino: $formatoCodigoDestino
                codigoBodega: $codigoBodega
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  folio
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_no_tributario.cambiaProducto;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerFoliosADocumentosGenerados(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query (
                $rut_emisor: Decimal, $sucursal_codigo: Decimal, $usuario_rut_usuario: Decimal, $folios: [Int]
                  ) {
                    documento_no_tributario {
                      obtenerDocumentosConvertidos(
                        filtro: { exacto: {
                          rut_emisor: $rut_emisor,
                          sucursal_codigo: $sucursal_codigo,
                        usuario_rut_usuario: $usuario_rut_usuario,
                        folios: $folios } }
                      )  {
                        mensajes {
                          codigo
                          contexto
                          tipo
                          texto
                        }
                        respuesta {
                          registros{
                            folio
                            nota_venta
                            cliente_nombre
                            vendedor_nombre
                            monto_total
                            monto_total_neto
                          }
                        }
                      }
                    }
                  }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_no_tributario.obtenerDocumentosConvertidos;
        callback({ mensajes, respuesta });
      }
    );
  }

  procesarResultadoAnalisis(
    inputParams: {
      rutEmpresa: number;
      sucursalCodigo: number;
      fechaDesde: Date;
      fechaHasta: Date;
      codigoBodega: number;
      unidadNegocio: number;
      producto_formatoSel: {
        producto_codigo: number;
        formato_codigo: string;
      }[];
    },
    callback: Function
  ) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation (
            $rutEmpresa: Decimal
            $sucursalCodigo: Decimal
            $fechaDesde: Date
            $fechaHasta: Date
            $codigoBodega: Decimal
            $unidadNegocio: Decimal
            $producto_formatoSel: [producto_formatoInputType]
            $rutUsuario: Decimal
          ) {
            documento_no_tributario {
              procesarResultadoAnalisis(
                rutEmpresa: $rutEmpresa
                sucursalCodigo: $sucursalCodigo
                fechaDesde: $fechaDesde
                fechaHasta: $fechaHasta
                codigoBodega: $codigoBodega
                unidadNegocio: $unidadNegocio
                producto_formatoSel: $producto_formatoSel
                rutUsuario: $rutUsuario
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  registros {
                    cantidadRequerida
                    detalleAnalisisDemanda {
                      cantidadAtendida
                      folio
                      producto_codigo
                      producto_formato
                      estado
                      stock_tras_movimiento
                      stock_Actual
                    }
                    diferenciaConStock
                    estado
                    folio
                    producto_codigo
                    producto_formato
                    stockActual
                    nombreFormato
                    nombreProducto
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_no_tributario.procesarResultadoAnalisis;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerDoctosProcesadosAnalisis(
    inputParams: {
      rutEmpresa: number;
      sucursalEmpresa: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
      soloAprobadosAnalisis: boolean;
      comunaSel: number;
      vendedorSel: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalEmpresa: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int, $soloAprobadosAnalisis: Boolean, $comunaSel: [Decimal], $vendedorSel: [Int]) {
            documento_no_tributario {
              obtenerDoctosProcesadosAnalisis(
                rutEmpresa: $rutEmpresa
                sucursalEmpresa: $sucursalEmpresa
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
                soloAprobadosAnalisis: $soloAprobadosAnalisis
                comunaSel: $comunaSel
                vendedorSel: $vendedorSel
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                  __typename
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    direccion_codigo
                    nombrecliente
                    direccion_cliente_rut
                    sucursal_codigo
                    rut_empresa
                    folio
                    tipo_dte_codigo
                    condicion_pago_codigo
                    estado_documento_codigo
                    vendedor_codigo
                    vendedor_nombre
                    comuna
                    rut_usuario_registro
                    fecha_emision
                    observacion_1
                    observacion_2
                    fecha_registro
                    folio_transformado
                    tipo_dte_codigo_transformado
                    totalBruto
                    total_neto
                    total
                    pedido_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_no_tributario.obtenerDoctosProcesadosAnalisis;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerSegunId(
    inputParams: {
      rut_empresa: number;
      folio: number;
      tipo_dte_codigo: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_empresa: Decimal, $folio: Decimal, $tipo_dte_codigo: Decimal) {
            documento_no_tributario {
              obtenerSegunId(entidad: { rut_empresa: $rut_empresa, folio: $folio, tipo_dte_codigo: $tipo_dte_codigo }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  direccion_cliente_rut
                  direccion_codigo
                  sucursal_codigo
                  rut_empresa
                  folio
                  tipo_dte_codigo
                  condicion_pago_codigo
                  estado_documento_codigo
                  vendedor_codigo
                  rut_usuario_registro
                  fecha_emision
                  observacion_1
                  observacion_2
                  fecha_registro
                  folio_transformado
                  tipo_dte_codigo_transformado
                  totalBruto
                  pedido_codigo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_no_tributario.obtenerSegunId;
        callback({ mensajes, respuesta });
      }
    );
  }

  validarPrecioCeroNotasVenta(
    inputParams: { rutEmpresa: number; sucursalCodigo: number; folios: number[] },
    callback: (result: { mensajes?: any[]; respuesta?: any[] }) => void
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $folios: [Decimal]) {
            documento_no_tributario {
              validarPrecioCeroNotasVenta(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, folios: $folios) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  folio
                  tipo_dte_codigo
                  tipo_dte_nombre
                  nro_linea
                  sku
                  descripcion_producto
                  precio_unitario
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      (response) => {
        const data = response.data && response.data.documento_no_tributario;
        const payload = data && data.validarPrecioCeroNotasVenta;
        const mensajes = (payload && payload.mensajes) || [];
        const respuesta = (payload && payload.respuesta) || [];
        callback({ mensajes, respuesta });
      }
    );
  }

  generaFacturasMasivas(
    inputParams: {
      fechaEmision: Date;
      rutEmpresa: number;
      sucursalCodigo: number;
      rutUsuario: number;
    },
    callback: Function
  ) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($fechaEmision: String, $rutEmpresa: Decimal, $sucursalCodigo: Decimal, $rutUsuario: Decimal, $folios: [Decimal]) {
            documento_no_tributario {
              generaFacturasMasivas(fechaEmision: $fechaEmision, rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, rutUsuario: $rutUsuario, folios: $folios) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    nota_venta
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                    tipo_traslado_codigo
                    condicion_pago_codigo
                    sucursal_codigo
                    vendedor_codigo
                    tipo_devolucion_codigo
                    fecha_emision
                    rut_receptor
                    direccion_completa_facturacion
                    comuna_facturacion
                    provincia_facturacion
                    region_facturacion
                    direccion_completa_despacho
                    comuna_despacho
                    princia_despacho
                    region_despacho
                    giro_cliente
                    fono_cliente
                    monto_descuento
                    monto_recargo
                    subtotal_neto
                    monto_total_neto
                    monto_iva
                    monto_afecto
                    monto_exento
                    subtotal
                    monto_total
                    nota_venta
                    orden_compra
                    fecha_registro
                    aplica_rebaja
                    aplica_recorrido
                    observaciones
                    ticket_sii
                    fecha_vencimiento
                    dia_emision
                    mes_emision
                    id_lsoft
                    motivo_devolucion_codigo
                    tipo_despacho_codigo
                    centro_costo_codigo
                    forma_pago_codigo
                    tipo_destinatario_codigo
                    es_entrega_gratuita
                    direccion_codigo
                    usuario_rut_usuario
                    tipo_ncnd_codigo
                    glosa_administrativa
                    recargo_global_pesos
                    descuento_global_porcentaje
                    recargo_global_porcentaje
                    lista_precio_codigo
                    cliente_nombre
                    vendedor_nombre
                    direccion_nombre
                    tipo_dte_nombre
                    aplica_nota_credito
                    es_exenta
                    afecto_reglas_comerciales
                    fue_afecto_nc_nd
                  }
                  detalleDocumento {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    formato_codigo
                    descripcion_producto
                    cantidad
                    precio_neto
                    precio_unitario
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    motivo_devolucion_especifico_codigo
                    es_correcion_monto
                    sku
                    descuento_linea_pesos
                    recargo_linea_pesos
                    descuento_linea_pesos
                    recargo_linea_pesos
                    descuento_linea_porcentaje
                    recargo_linea_porcentaje
                    aplicacion_descuento
                    aplicacion_recargo
                    aplicacion_imp_adic
                    tipo_producto_codigo
                    es_afecto_reglas_comerciales
                    es_exento
                    promocion_codigo
                    descuento_codigo
                    es_combo
                    es_descuento
                    es_promocion
                    es_promocion_condicional
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                  descuentosGlobales {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    es_porcentaje
                    monto_descuento
                    es_descuento
                    glosa
                    ind_facturacion
                    es_exento
                  }
                  logErrores {
                    codigo
                    contexto
                    texto
                    tipo
                  }
                  estadoFactura
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
        // context: '{ timeout: 300000 }'
        ...opcionesDeConfiguracion,
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_no_tributario.generaFacturasMasivas;
        callback({ mensajes, respuesta });
      }
    );
  }
}
